import { render, staticRenderFns } from "./AiSuggestionBasicParser.vue?vue&type=template&id=2b883fc3"
import script from "./AiSuggestionBasicParser.vue?vue&type=script&lang=js"
export * from "./AiSuggestionBasicParser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports